import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AppGlobalsModule } from 'src/app/app-globals.module';
import { I18nService } from './i18n/i18n.service';
@Injectable({
    providedIn: 'root',
})
export class IconsService {
    private matIconRegistry = inject(MatIconRegistry);
    private domSanitizer = inject(DomSanitizer);
    private i18n = inject(I18nService);
    private iconsRegistered = false;
    private shareIconsRegistered = false;


    public registerIcons() {
        if (this.iconsRegistered) {
            return;
        }

        this.iconsRegistered = true;
        const langShort = this.i18n.getLangshort();
        // ~~You can stack svg icon using "https://icomoon.io/app/"
        // make sure to replace < symbol > to < svg > due to Angular looking for nested SVG. * shrugs *~~
        // The above is irellevant, just stack them yourself.

        // Global icons:
        // Broadcast, Youtube, Facebook,
        this.matIconRegistry.addSvgIconSet(
            this.domSanitizer.bypassSecurityTrustResourceUrl(AppGlobalsModule.svgAssetsFullPath(langShort) + 'sets/global-icons.svg'),
        );

        let formatTypes = ['video', 'audio', 'paper'];
        formatTypes.forEach((format) => {
            this.matIconRegistry.addSvgIcon(
                format + '-selected',
                this.domSanitizer.bypassSecurityTrustResourceUrl(AppGlobalsModule.svgAssetsFullPath(langShort) + format + '/filt-selected.svg'),
            );
            this.matIconRegistry.addSvgIcon(
                format + '-unselected',
                this.domSanitizer.bypassSecurityTrustResourceUrl(AppGlobalsModule.svgAssetsFullPath(langShort) + format + '/filt-unselected.svg'),
            );
            this.matIconRegistry.addSvgIcon(
                format + '-color',
                this.domSanitizer.bypassSecurityTrustResourceUrl(AppGlobalsModule.svgAssetsFullPath(langShort) + format + '/icn-color.svg'),
            );
            this.matIconRegistry.addSvgIcon(
                format + '-gray',
                this.domSanitizer.bypassSecurityTrustResourceUrl(AppGlobalsModule.svgAssetsFullPath(langShort) + format + '/icn-gray.svg'),
            );
        });
    }

    public registerShareIcons() {
        if (this.shareIconsRegistered) {
            return;
        }

        this.shareIconsRegistered = true;
        const langShort = this.i18n.getLangshort();

        this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl(AppGlobalsModule.svgAssetsFullPath(langShort) + 'sets/share-icons.svg'));
    }

    setIconsSetPath(path: string, langShort: string) {
        this.matIconRegistry.addSvgIconSet(this.domSanitizer.bypassSecurityTrustResourceUrl(AppGlobalsModule.assetsPath(langShort) + 'svg/sets/' + path));
    }
}
